<section class="partners-section py-5">
  <div class="container">
    <div class="row mb-5 text-center">
      <div class="col-12">
        <h2 class="fw-bold">شركاء النجاح</h2>
        <div class="heading-line mx-auto"></div>
      </div>
    </div>

    <div class="row align-items-center justify-content-center g-4">
      <div *ngFor="let item of partners" class="col-6 col-md-3 col-lg-3 col-xl-3">
        <div class="partner-card p-3 shadow-sm bg-dark rounded-3 d-flex align-items-center justify-content-center">
          <img [src]="item.src" [alt]="item.alt" [title]="item.title" class="img-fluid partner-logo">
        </div>
      </div>
    </div>
  </div>
</section>
<footer class="footer">
  <div class="footer-container">
    <div class="footer-content">
      <!-- Logo Section -->
      <div class="footer-section footer-logo">
        <div class="footer-logo-wrapper">
          <img src="../../../assets/Bahgat Law Firm (1).png" alt="مؤسسة بهجت للمحاماة" class="footer-logo-image" />
        </div>
        <p class="footer-description">
          {{ siteData?.site?.description || "" }}
        </p>
      </div>

      <!-- Quick Links Section -->
      <div class="footer-section footer-links">
        <h4 class="footer-title">روابط سريعة</h4>
        <ul class="footer-links-list">
          <li *ngFor="let link of siteData?.navigation?.links">
            <a [routerLink]="link.url" routerLinkActive="active" class="footer-link">
              {{ link.text }}
            </a>
          </li>
        </ul>
      </div>

      <!-- Contact Info Section -->
      <div class="footer-section footer-contact" *ngIf="siteData?.contact">
        <h4 class="footer-title">معلومات التواصل</h4>
        <div class="footer-contact-info" *ngIf="siteData?.contact?.info">
          <div class="contact-item" *ngFor="let info of siteData?.contact?.info" [class.clickable]="
              info.icon === 'location' ||
              info.icon === 'phone' ||
              info.icon === 'email'
            ">
            <!-- Location - Clickable to open Google Maps -->
            <div *ngIf="info.icon === 'location'" class="contact-link" title="افتح في Google Maps">
              <div class="contact-icon-wrapper">
                <svg class="contact-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path
                    d="M12 0C7.589 0 4 3.589 4 8c0 6.896 8 16 8 16s8-9.104 8-16c0-4.411-3.589-8-8-8zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z" />
                </svg>
              </div>
              <div class="contact-content">
                <a class="contact-value" *ngFor="let content of info.content" (click)="openGoogleMaps(content)"
                  [href]="content" target="_blank">{{ content }}</a>
              </div>
            </div>

            <!-- Phone - Clickable to call -->
            <div *ngIf="info.icon === 'phone'" class="contact-link" title="اتصل">
              <div class="contact-icon-wrapper">
                <svg class="contact-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path
                    d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 0 0-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z" />
                </svg>
              </div>
              <div class="contact-content">
                <a class="contact-value" *ngFor="let content of info.content" href="tel:{{ content }}">{{ content }}</a>
              </div>
            </div>

            <!-- Email - Clickable to send email -->
            <!-- (click)="openEmail(getFirstEmail())" -->
            <div *ngIf="info.icon === 'email'" class="contact-link" title="أرسل بريد إلكتروني">
              <div class="contact-icon-wrapper">
                <svg class="contact-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path
                    d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                </svg>
              </div>
              <div class="contact-content">
                <a class="contact-value" *ngFor="let content of info.content" href="mailto:{{ content }}">{{ content
                  }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Social Links Section -->
      <div class="footer-section footer-social" *ngIf="siteData?.site?.social">
        <h4 class="footer-title">تابعنا</h4>
        <div class="social-links">
          <a *ngIf="siteData?.site?.social?.facebook" [href]="siteData?.site?.social?.facebook" target="_blank"
            rel="noopener noreferrer" class="social-link facebook" aria-label="Facebook">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
            </svg>
          </a>
          <a *ngIf="siteData?.site?.social?.twitter" [href]="siteData?.site?.social?.twitter" target="_blank"
            rel="noopener noreferrer" class="social-link twitter" aria-label="Twitter">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
            </svg>
          </a>
          <a *ngIf="siteData?.site?.social?.linkedin" [href]="siteData?.site?.social?.linkedin" target="_blank"
            rel="noopener noreferrer" class="social-link linkedin" aria-label="LinkedIn">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
            </svg>
          </a>
          <a *ngIf="siteData?.site?.social?.instagram" [href]="siteData?.site?.social?.instagram" target="_blank"
            rel="noopener noreferrer" class="social-link instagram" aria-label="Instagram">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
            </svg>
          </a>
          <a *ngIf="siteData?.site?.social?.youtube" [href]="siteData?.site?.social?.youtube" target="_blank"
            rel="noopener noreferrer" class="social-link youtube" aria-label="YouTube">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
            </svg>
          </a>
          <a *ngIf="siteData?.site?.social?.whatsapp" [href]="siteData?.site?.social?.whatsapp" target="_blank"
            rel="noopener noreferrer" class="social-link whatsapp" aria-label="WhatsApp">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
            </svg>
          </a>
        </div>
      </div>
    </div>

    <!-- Copyright Section -->
    <div class="footer-bottom">
      <div class="footer-copyright">
        <p>
          جميع الحقوق محفوظة
          <a href="https://maps.app.goo.gl/hJQ7Zxg4yhs26HDo7" target="_blank" class="copyright-name">Perfect Solution
            4U</a>
          <span class="copyright-year">© 2026</span>
        </p>
      </div>
    </div>
  </div>
</footer>